const newsMeta = {
  permissionInfo: {
    key: "search",
    region: true,
    range: true,
    children: [
      {
        key: "register",
        region: true,
      },
    ],
  },
};

const recipientMeta = {
  permissionInfo: {
    key: "recipient",
    range: true,
    children: [
      {
        key: "register",
        region: true,
      },
    ],
  },
};

export default [
  {
    path: "/",
    redirect: "/news",
  },
  {
    path: "/news",
    component: () => import("$views/News/All.General"),
    meta: newsMeta,
  },
  {
    path: "/repeat_news",
    component: () => import("$views/News/All.Repeat"),
    meta: newsMeta,
  },
  {
    path: "/news/recipient/:id",
    component: () => import("$views/News/Recipient"),
    children: [
      {
        path: "",
        redirect: "general",
      },
      {
        path: ":tab",
        meta: recipientMeta,
      },
    ],
    meta: recipientMeta,
  },
];
